var _excluded = ["children", "className", "kind", "tag", "icon", "type", "iconProps"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import Icon from '../icons';
require("./pill.css");
var styles = {
  "pill": "pill-2i_OA",
  "pillPrimary": "pillPrimary-omLFf",
  "pillSecondary": "pillSecondary-2s4zo",
  "pillFilter": "pillFilter-2dtVA",
  "pillTertiary": "pillTertiary-3WNhJ",
  "iconPillTextLeft": "iconPillTextLeft-tQd1B",
  "iconPillTextRight": "iconPillTextRight-hBktz",
  "iconPillContent": "iconPillContent-1QtEN",
  "iconPillIconSmall": "iconPillIconSmall-3phEI",
  "iconPillIcon": "iconPillIcon-MerPD"
};
var iconChildren = (children, icon, iconProps) => {
  var {
    position,
    className
  } = iconProps || {};
  // maintain backward compability: icon = html node (existing), iconProps = object (new)
  var isDeprecated = !!icon;
  var iconPosition = isDeprecated ? 'right' : position;
  var iconNode = /*#__PURE__*/React.createElement(Icon, {
    className: cs({
      [styles.iconPillIconSmall]: isDeprecated,
      [styles.iconPillIcon]: !isDeprecated
    }, className),
    content: isDeprecated ? icon : iconProps.icon
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles.iconPillContent
  }, iconPosition === 'left' && iconNode, /*#__PURE__*/React.createElement("span", {
    className: cs({
      [styles.iconPillTextLeft]: iconPosition === 'left',
      [styles.iconPillTextRight]: iconPosition === 'right'
    })
  }, children), iconPosition === 'right' && iconNode);
};
var Pill = _ref => {
  var {
      children,
      className,
      kind,
      tag,
      icon,
      type,
      iconProps
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var Tag = tag;
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: cs(styles.pill, className, {
      [styles.pillPrimary]: kind === 'primary',
      [styles.pillSecondary]: kind === 'secondary',
      [styles.pillTertiary]: kind === 'tertiary',
      [styles.pillFilter]: kind === 'filter'
    }),
    type: Tag === 'button' ? type : undefined
  }, otherProps), icon || iconProps ? iconChildren(children, icon, iconProps) : children);
};
Pill.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  kind: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'filter']),
  /** Controls the HTML tag that this component renders */
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  /** Deprecated: icon is replaced by iconProps */
  icon: PropTypes.node,
  iconProps: PropTypes.shape({
    icon: PropTypes.node,
    position: PropTypes.oneOf(['left', 'right']),
    className: PropTypes.string
  })
};
Pill.defaultProps = {
  className: null,
  kind: 'secondary',
  tag: 'div',
  type: 'button',
  icon: null,
  iconProps: null
};
export default Pill;